import { AnimatedSprite, Container, Sprite, Texture } from 'pixi.js';
import { Store, TextureFactory } from '../core';

class CostumeItem extends Container {
  private sprite: AnimatedSprite;
  private selectedSprite: Sprite;
  public selected: boolean = false;
  public type: number;

  constructor(type: number) {
    super();

    this.type = type;

    const textures: Array<Texture> = [];
    textures.push(
      TextureFactory.instance.getSingleTexture(`/textures/ui/unlocked_${type}.png`),
      TextureFactory.instance.getSingleTexture(`/textures/ui/locked_0.png`),
      TextureFactory.instance.getSingleTexture(`/textures/ui/locked_${type}.png`)
    );

    const selectedTexture = TextureFactory.instance.getSingleTexture('/textures/ui/selected.png');
    this.selectedSprite = new Sprite(selectedTexture);
    this.selectedSprite.visible = false;
    this.selectedSprite.anchor.set(0.5);
    this.addChild(this.selectedSprite);

    this.sprite = new AnimatedSprite(textures);
    this.sprite.anchor.set(0.5);
    this.addChild(this.sprite);
  }

  public update(): void {
    this.selectedSprite.visible = this.selected;

    const hasCostume = Store.instance.data.costumes[this.type];

    if (this.selected) {
      if (hasCostume) {
        this.sprite.gotoAndStop(0);
      } else {
        this.sprite.gotoAndStop(2);
      }
    } else {
      if (hasCostume) {
        this.sprite.gotoAndStop(0);
      } else {
        this.sprite.gotoAndStop(1);
      }
    }
  }
}

export default CostumeItem;
